<template>
  <div class="houseList">
    <div class="top">
      <div class="top_title">
        <div class="title">
          <h1>售房/房源</h1>
          <a-button type="primary" @click="addHouse" class="el_button el-button--primary"> 新增房源 </a-button>
        </div>
      </div>
      <div class="searchBox">
        <div style="width: 100%">
          <a-row class="paddingL20">
            <a-col :span="5">
              <a-form-item class="search">
                <a-input v-model="form.search" @pressEnter="searchBtn" placeholder="智能搜索">
                  <a-icon slot="prefix" type="search" />
                </a-input>
              </a-form-item>
            </a-col>
          </a-row>
          <a-form :model="searchForm" :label-col="labelCol" :wrapper-col="wrapperCol" v-if="downShow">
            <a-row class="paddingL20">
              <a-col :span="5">
                <a-form-item label="区域">
                  <a-select
                    mode="multiple"
                    show-search
                    option-filter-prop="children"
                    @change="regionChange"
                    v-model="form.districtIdList"
                    class="w150"
                  >
                    <a-select-option v-for="item in districtList" :key="item.areaId" :value="item.areaId">{{
                      item.areaName
                    }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="5">
                <a-form-item label="商圈">
                  <a-select
                    show-search
                    option-filter-prop="children"
                    v-model="form.businessDistrictIdList"
                    mode="multiple"
                    @change="businessDistrictMethod"
                    class="w150"
                  >
                    <a-select-option v-for="item in businessDistrictList" :key="item.id" :value="item.id">{{
                      item.businessDistrictName
                    }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="街道">
                  <a-select
                    show-search
                    option-filter-prop="children"
                    v-model="form.streetIdList"
                    mode="multiple"
                    class="w150"
                  >
                    <a-select-option v-for="item in streetList" :key="item.id" :value="item.id">{{
                      item.streetFullName
                    }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item label="面积" class="mj" :style="{ display: 'inline-block', width: '100%' }">
                  <a-input
                    placeholder="开始"
                    class="w75"
                    v-model="form.startAcreage"
                    @input="intValidate('startAcreage')"
                  />-
                  <a-input
                    placeholder="结束"
                    class="w75"
                    v-model="form.endAcreage"
                    @input="intValidate('endAcreage')"
                  />m²
                </a-form-item>
              </a-col>
            </a-row>
            <a-row class="paddingL20">
              <a-col :span="5">
                <a-form-item label="类型">
                  <a-select v-model="form.saleType" class="w150">
                    <a-select-option value="" key="0"> 全部 </a-select-option>
                    <a-select-option value="1" key="1"> 售价 </a-select-option>
                    <a-select-option value="2" key="2"> 单价 </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="5">
                <a-form-item label="楼层">
                  <!-- mode="multiple" -->
                  <a-select :show-arrow="true" v-model="form.houseFloorTypeList" class="w75" @change="houseFloorChange">
                    <a-select-option v-for="item in floorTypeOpts" :key="item.dictLabel" :value="item.dictValue">
                      {{ item.dictLabel }}
                    </a-select-option>
                  </a-select>
                  <a-input
                    v-if="form.houseFloorTypeList === '1'"
                    class="w75 ml5"
                    type="text"
                    v-model="form.houseFloor"
                    placeholder="楼层数"
                    :maxLength="7"
                    @input="intValidate('houseFloor')"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="可否餐饮">
                  <a-select
                    show-search
                    option-filter-prop="children"
                    mode="multiple"
                    v-model="form.alloweCateringTypeIdList"
                    class="w150"
                  >
                    <a-select-option v-for="item in repastType" :key="item.dictValue" :value="item.dictValue">{{
                      item.dictLabel
                    }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item label="维护人">
                  <a-tree-select
                    v-model="mixin_deptId"
                    style="width:200px"
                    :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                    :tree-data="deptOptions"
                    placeholder="部门"
                    :replaceFields="replaceFields"
                    tree-default-expand-all
                    @change="handleChangeTree"
                  >
                  </a-tree-select
                  >-
                  <a-select
                    v-model="form.accendantId"
                    @dropdownVisibleChange="handleOption($event)"
                    placeholder="请选择人员"
                    style="width:200px"
                  >
                    <a-select-option v-for="item in userList" :key="item.userId" :value="item.userId">
                      {{ item.nickName }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row class="paddingL20">
              <a-col :span="6">
                <a-form-item
                  label="售价"
                  :label-col="{ span: 5 }"
                  :wrapper-col="{ span: 19 }"
                  class="mj"
                  :style="{ display: 'inline-block', width: '100%' }">
                  <a-input placeholder="开始" class="w75" v-model="form.startRentFee" />-<a-input placeholder="结束" class="w75" v-model="form.endRentFee" /> 元
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item
                  :label-col="{ span: 4 }"
                  :wrapper-col="{ span: 20 }"
                  label="单价">
                  <a-input placeholder="开始" class="w75" v-model="form.startUnitPrice" />-<a-input placeholder="结束" class="w75" v-model="form.endUnitPrice" /> 元
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="日期" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                  <a-select v-model="form.dateType" default-value="" class="w150 mr10" @change="rqselectMethod">
                    <a-select-option value="" key="0">全部</a-select-option>
                    <a-select-option value="1" key="1">跟进日期</a-select-option>
                    <a-select-option value="2" key="2">录入日期</a-select-option>
                  </a-select>
                  <template v-if="form.dateType">
                    <a-date-picker :disabled="rqflag" style="width: 118px" v-model="form.startTime" />
                    -
                    <a-date-picker :disabled="rqflag" style="width: 118px" v-model="form.endTime" />
                  </template>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row class="paddingL20">
              <a-col :span="10">
                <a-form-item label="行业" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                  <a-select
                    show-search
                    option-filter-prop="children"
                    mode="multiple"
                    v-model="form.industryCategoryJsonId"
                    @change="getSubIndustryList"
                    class="w150"
                  >
                    <a-select-option :value="item.id" v-for="item in canIndustryList" :key="item.id">{{
                      item.industryCategoryName
                    }}</a-select-option>
                  </a-select>
                  <a-select
                    show-search
                    option-filter-prop="children"
                    mode="multiple"
                    v-model="form.industrySubclassJsonId"
                    class="w150 ml5"
                  >
                    <a-select-option :value="item.id" v-for="item in canSubIndustryList" :key="item.id">{{
                      item.industryCategoryName
                    }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <!-- <a-col :span="5">
                <a-form-item label="有无转让费" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
                  <a-select v-model="form.isHaveTransferFee" class="w75 mr10">
                    <a-select-option :value="item.dictValue" v-for="item in weatherOpts" :key="item.dictLabel">{{
                      item.dictLabel
                    }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col> -->
              <a-col :span="12">
                <a-form-item label="状态" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                  <a-select v-model="form.houseStatus" class="w150 mr10">
                    <a-select-option :value="item.dictValue" v-for="item in houseStatusData" :key="item.dictLabel">{{
                      item.dictLabel
                    }}</a-select-option>
                  </a-select>
                  <a-button
                    class="btn mr10"
                    style="border: 1px solid var(--ThemeColor); color: var(--ThemeColor)"
                    @click="reset"
                  >重置</a-button
                  >
                  <a-button class="btn mr10" type="primary" @click="searchBtn">查询</a-button>
                  <a-button type="primary" @click="export_houseList" v-hasPermi="['houses:sellHouseInfo:export']">
                    <a-icon type="download" />导出
                  </a-button>
                </a-form-item>
              </a-col>
              <a-col :span="6"> </a-col>
            </a-row>
            <div style="text-align: right; padding-right: 143px"></div>
          </a-form>
        </div>
      </div>
    </div>
    <div class="midhr"></div>
    <div class="content" style="padding: 20px">
      <a-tabs
        type="card"
        class="menu"
        :defaultActiveKey="activeNum"
        @change="HouseMethod"
      ><!-- v-if="" -->
        <a-tab-pane v-for="(item, index) in getTabs" :key="index + 1" :tab="item.title"></a-tab-pane>
      </a-tabs>
      <ListItem
        :isSell="isSell"
        ref="ListItem"
        @houselistsort="houselistsort"
        @dateTypeChangeHandle="dateTypeChangeHandle"
        :sortType="form.sortType"
        :houseResourceType="form.houseResourceType"
        :dateTypeOpts="dateTypeOpts"
        :records="records"
        :sort="sort"
        :activeNum="activeNum"
      ></ListItem>
      <a-pagination
        :current="form.pageNum"
        :page-size="form.pageSize"
        :showTotal="(total) => `共 ${total} 条`"
        :total="pagination.total"
        @showSizeChange="onChange"
        @change="onChange"
        class="dateli"
      />
    </div>
    <div class="topcenter" v-show="loading">
      <LoadingModel></LoadingModel>
    </div>
  </div>
</template>

<script>
import LoadingModel from '@/components/Loading'
// import houseListVue from '@/components/houseList/houseList.vue'
import houseListSellVue from '@/components/houseList/houseSellList.vue'
import { contractsInfoSaleList } from '@/api/system/houses/houseSale'
import houseApi from '@/api/system/houses/house.js'
import touristApi from '@/api/system/tourist/tourist'
import moment from 'moment'
import { treeSelectMixin } from '@/mixin/treeSelect'
import { locationSelectMixin } from '@/mixin/locationSelect'
import { industryClassSelMixin } from '@/mixin/industrySelect'
import ListItem from './components/listItem.components.vue'
import {
  getYMD,
  getBeginYesterday,
  getEndYesterday,
  getBeginWeek,
  getBeginLastWeek,
  getEndLastWeek,
  getBeginMonth,
  getEndMonth,
  getBeginLastMonth,
  getEndLastMonth
} from '@/utils/date.js'
const tabsList = [
  {
    key: 1,
    title: '全部房源'
  },
  {
    key: 2,
    title: '我的房源'
  },
  {
    key: 3,
    title: '门店公盘'
  },
  {
    key: 4,
    title: '公司公盘'
  },
  {
    key: 5,
    title: '即将掉盘'
  },
  {
    key: 6,
    title: '下架'
  }
]
export default {
  name: 'HousesListSell',
  components: {
    LoadingModel,
    ListItem,
    houseListSellVue
  },
  mixins: [treeSelectMixin, locationSelectMixin, industryClassSelMixin],
  computed: {
    // 获取tabs,如总经理等无我的房源
    getTabs () {
      const arr = ['ZJL']
      const loginRole = this.$getters.userInfo.data.roles
      let status = false
      loginRole.forEach(el => {
        if (arr.includes(el)) {
          status = true
        }
      })
      if (status) {
        this.tabsList = tabsList.filter(el => el.key == 1)
      } else {
        this.tabsList = tabsList
      }
      return this.tabsList
    }
  },
  data () {
    return {
      tabsList,
      isSell: true, // 是否为售房管理
      activeNum: 1,
      rentUnit: '', // 租金单位
      form_startRentFee: undefined, // 租金开始（显示的）
      form_endRentFee: undefined, // 租金结束（显示的）
      rentStartDate: undefined, // 日租金开始
      rentEndDate: undefined, // 日租金结束
      rentStartMonth: undefined, // 月租金开始
      rentEndMonth: undefined, // 月租金结束
      // 加载
      loading: false,
      // 信息
      AllList: [],
      // 日期控制禁用
      rqflag: true,
      // 租金切换
      zujinfalg: true,
      // 列表数据
      records: [],
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
      // 查询表单
      searchForm: {
        rqselect: 'all',
        rqstart: '',
        rqend: ''
      },
      pagination: {
        current: 1,
        total: 1,
        size: 3
      },
      sort: 1,
      direction: 'down',
      direction2: 'down',
      direction3: 'down',
      direction4: 'down',
      direction5: 'down',
      direction6: 'down',
      form: {
        hourseSort: 1,
        dateType: '',
        houseResourceType: 1,
        pageNum: 1,
        pageSize: this.$getters.pageSize,
        sortType: 'DESC',
        // sortType: '',
        storeId: undefined, // 门店ID（维护人）
        teamId: undefined, // 部门ID（维护人）
        accendantId: '', // 维护人
        // alloweCateringTypeId: [],
        // businessDistrictId: [],
        // districtId: [],
        // streetId: [],
        endAcreage: undefined,
        endInMoreNum: '',
        saleType: '',
        endRentFee: null,
        endTime: '',
        houseFloor: '',
        houseStatus: '1',
        isAsc: '',
        orderByColumn: '',
        search: '',
        shopType: '',
        startAcreage: undefined,
        startInMoreNum: '',
        startRentFee: null,
        startTime: '',

        transferFee: '',
        region: undefined,
        // 多选
        districtIdList: [],
        businessDistrictIdList: [],
        alloweCateringTypeIdList: [],
        streetIdList: [],

        industryCategoryId: undefined, // 行业分类ID	query	false	string
        industrySubclassId: undefined, // 经营行业ID	query	false	string
        industryCategoryJsonId: [], // 行业大类ID（可经营）(多选，以“，”隔开)
        industrySubclassJsonId: [], // 行业小类ID（可经营）	(多选，以“，”隔开)
        // 楼层
        houseFloorTypeList: '',
        startHouseFloor: '',
        endHouseFloor: '',
        isHaveTransferFee: undefined // 是否接受转让费 字典表类型：sys_yes_no
      },
      // 维护人 部门
      newForm: {
        deptId: ''
      },
      // 查询框更多按钮事件
      downShow: true,
      // 房源状态(有效,已租,我租,不租,错误)
      houseStatusData: [{ dictLabel: '全部', dictValue: '' }],
      // 区域列表
      districtData: [],
      // 商圈列表
      businessDistrict: [],
      // 商铺类型
      shopType: [{ dictLabel: '全部', dictValue: '' }],
      // 街道列表
      StreetData: [],
      // 带看日期范围
      dateTypeOpts: [
        { id: 1, name: '今日' },
        { id: 2, name: '昨日' },
        { id: 3, name: '本周' },
        { id: 4, name: '上周' },
        { id: 5, name: '本月' },
        { id: 6, name: '上月' },
        { id: 7, name: '全部' }
      ],

      // 楼层数
      floorData: [],
      // 楼层类型
      floorTypeOpts: [{ dictLabel: '全部', dictValue: '' }],
       weatherOpts: [], // 是否
      // 餐饮类型
      repastType: [],
      // 人员部门
      PersonGav: [],
      a: null,
      // 维护人所属部门id
      PersonId: '',
      // 部门列表
      deptListData: [],
      // 部门对应人员
      depPerson: [],
      userList: []
    }
  },
  created () {
    // 获取房源信息列表
    this.dataList()
    // 获取部门
    this.getDep()
    // 房源状态
    this.getDicts('house_status').then((res) => {
      if (res.code === 200) {
        const list = res.data.filter((item) => item.dictValue !== 4)
        // list.forEach((res) => {
        //   switch (Number(res?.dictValue)) {
        //     case 1:
        //       res.dictLabel = '上架'
        //       break
        //     case 2:
        //       res.dictLabel = '我司成交'
        //       break
        //     case 3:
        //       res.dictLabel = '自行成交'
        //       break
        //     case 4:
        //       res.dictLabel = '无效'
        //       break
        //     case 6:
        //       res.dictLabel = '下架'
        //       break
        //     default:
        //       break
        //   }
        // })
        this.houseStatusData = this.houseStatusData.concat(list)
      }
    })
    // 商铺类型
    this.getDicts('shop_type').then((res) => {
      if (res.code === 200) {
        this.shopType = this.shopType.concat(res.data)
      }
    })
    this.getDicts('sys_yes_no').then((response) => {
      this.weatherOpts = response.data
    })
    // 楼层数
    this.getDicts('floor_num').then((res) => {
      if (res.code === 200) {
        this.floorData = res.data
      }
    })
    // 楼层数
    this.getDicts('floor_type').then((res) => {
      if (res.code === 200) {
        this.floorTypeOpts = this.floorTypeOpts.concat(res.data)
      }
    })

    // 维护人所属部门id
    this.getDicts('related_personne_type').then((res) => {
      if (res.code === 200) {
        this.PersonGav = res.data
        this.a = this.PersonGav.find((item) => {
          return item.dictLabel === '维护人'
        })
        this.PersonId = this.a.dictSort
      }
    })

    // 餐饮类型
    this.getDicts('repast_type').then((res) => {
      if (res.code === 200) {
        this.repastType = res.data
      }
    })
  },

  methods: {
    // 导出-房源信息查询列表
    export_houseList () {
      if (this.form.startTime) {
        this.form.startTime = moment(this.form.startTime).format('YYYY-MM-DD')
      }
      if (this.form.endTime) {
        this.form.endTime = moment(this.form.endTime).format('YYYY-MM-DD')
      }

      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据',
        onOk () {
          that.downloadPost(
            '/houses/houseInfoSale/export',
            {
              ...that.form
            },
            `p_${new Date().getTime()}.xls`
          )
        },
        onCancel () {}
      })
    },
    // int验证
    intValidate (fieldName) {
      const val = this[fieldName]
      const reg = /^[0-9]{1,6}$/
      if (reg.test(val)) {
        if (!isNaN(val)) {
          this[fieldName] = parseInt(val)
        }
      } else {
        this[fieldName] = 0
      }
    },
    // 是否首页进入-即将掉盘
    dataList () {
      if (this.$route.query.str) {
        this.activeNum = '5'
        this.HouseMethod(5)
      } else {
        this.activeNum = '1'
        this.houseList()
      }
    },
    dateTypeChangeHandle (e) {
      this.$refs.ListItem.selectValue = e
      // 日期
      let startTime = ''
      let endTime = ''
      if (e === 1) {
        // 今日
        startTime = getYMD('-', new Date())
        endTime = getYMD('-', new Date())
      } else if (e === 2) {
        // 昨日
        startTime = getYMD('-', getBeginYesterday())
        endTime = getYMD('-', getEndYesterday())
      } else if (e === 3) {
        // 本周
        startTime = getYMD('-', getBeginWeek())
        endTime = getYMD('-', getEndYesterday())
      } else if (e === 4) {
        // 上周
        startTime = getYMD('-', getBeginLastWeek())
        endTime = getYMD('-', getEndLastWeek())
      } else if (e === 5) {
        // 本月
        startTime = getYMD('-', getBeginMonth())
        endTime = getYMD('-', getEndMonth())
      } else if (e === 6) {
        // 上月
        startTime = getYMD('-', getBeginLastMonth())
        endTime = getYMD('-', getEndLastMonth())
      } else if (e === 7) {
        // 所有
        startTime = undefined
        endTime = undefined
      } else {
        startTime = undefined
        endTime = undefined
      }
      this.form.startInMoreTime = startTime // 带看开始时间
      this.form.endInMoreTime = endTime // 带看结束时间
      this.houseList()
    },
    // 房源排序方法
    houselistsort (sortType) {
      this.sort = sortType
      this.form.hourseSort = sortType // 房源排序（1：默认 2：租金(元/月) 3：租金(元/平方米/月) 4：带看 5：面积 6：盘别）
      if (sortType === 8) {
        const direction_ = this.direction2 // up 升 down 降
        this.form.sortType = direction_ === 'up' ? 'ASC' : 'DESC'
        this.direction2 = direction_ === 'up' ? 'down' : 'up'
      } else if (sortType === 7) {
        const direction_ = this.direction3 // up 升 down 降
        this.form.sortType = direction_ === 'up' ? 'ASC' : 'DESC'
        this.direction3 = direction_ === 'up' ? 'down' : 'up'
      } else if (sortType === 4) {
        const direction_ = this.direction4 // up 升 down 降
        this.form.sortType = direction_ === 'up' ? 'ASC' : 'DESC'
        this.direction4 = direction_ === 'up' ? 'down' : 'up'
      } else if (sortType === 5) {
        const direction_ = this.direction5 // up 升 down 降
        this.form.sortType = direction_ === 'up' ? 'ASC' : 'DESC'
        this.direction5 = direction_ === 'up' ? 'down' : 'up'
      } else if (sortType === 6) {
        const direction_ = this.direction6 // up 升 down 降
        this.form.sortType = direction_ === 'up' ? 'ASC' : 'DESC'
        this.direction6 = direction_ === 'up' ? 'down' : 'up'
      }
      this.houseList()
    },
    // 查询
    searchBtn () {
      this.houseList()
    },
    // 重置
    reset () {
      this.form_startRentFee = undefined
      this.form_endRentFee = undefined
      this.sort = 1
      this.form = {
        hourseSort: 1,
        // houseResourceType:1,//分类重置 当前标签是不是也要重置
        houseResourceType: this.form.houseResourceType,
        pageNum: 1,
        pageSize: this.$getters.pageSize,
        sortType: 'DESC',
        storeId: undefined, // 门店ID（维护人）
        teamId: undefined, // 部门ID（维护人）
        accendantId: '', // 维护人
        dateType: '',
        endAcreage: '',
        endInMoreNum: '',
        endRentFee: undefined,
        endTime: '',
        houseFloor: '',
        houseStatus: '',
        isAsc: '',
        orderByColumn: '',
        search: '',
        saleType: '',
        shopType: '',
        startAcreage: '',
        startInMoreNum: '',
        startRentFee: undefined,
        startTime: '',
        transferFee: '',
        businessDistrictName: '',

        alloweCateringTypeId: [],
        businessDistrictId: [],
        districtId: [],
        streetId: [],
        // 多选
        districtIdList: [],
        businessDistrictIdList: [],
        alloweCateringTypeIdList: [],
        streetIdList: [],
        industryCategoryId: undefined, // 行业分类ID	query	false	string
        industrySubclassId: undefined, // 经营行业ID	query	false	string
        industryCategoryJsonId: [], // 行业大类ID（可经营）(多选，以“，”隔开)
        industrySubclassJsonId: [], // 行业小类ID（可经营）	(多选，以“，”隔开)
        // 楼层
        houseFloorTypeList: '',
        startHouseFloor: '',
        endHouseFloor: '',
        isHaveTransferFee: undefined // 是否接受转让费 字典表类型：sys_yes_no
      }
      this.newForm.deptId = ''
      this.mixin_deptId = undefined
      this.searchBtn()
    },
    onChange (current, pageSize) {
      this.form.pageNum = current
      this.form.pageSize = pageSize

      this.houseList()
    },
    // 房源信息查询列表
    houseList () {
      this.loading = true
      this.records = []
      if (this.form.startTime) {
        this.form.startTime = moment(this.form.startTime).format('YYYY-MM-DD')
      }
      if (this.form.endTime) {
        this.form.endTime = moment(this.form.endTime).format('YYYY-MM-DD')
      }
      contractsInfoSaleList(this.form).then((res) => {
        console.log(res, '出售房源信息列表')
        if (res.code === 200) {
          this.records = res.data.records
          this.pagination.total = res.data.total
          this.loading = false
        } else {
          this.$message.warning('房源信息获取失败')
          this.loading = false
        }
      })
    },

    // 日期选择事件
    rqselectMethod (val) {
      this.searchForm.rqstart = ''
      this.searchForm.rqend = ''
      if (val === 'all') {
        this.rqflag = true
      } else {
        this.rqflag = false
      }
    },
    // 租金切换方法
    zujin (val) {
      if (val === 1) {
        this.zujinfalg = true // 为日租金
      } else {
        this.zujinfalg = false // 为月租金
      }
    },
    // 部门列表
    getDep () {
      houseApi.deptList().then((res) => {
        if (res.code === 200) {
          this.deptListData = res.data

          // this.districtData = res.data
        }
      })
    },
    getDeptSubHandle (val) {
      this.form.accendantId = ''
      this.getDepPerson(val)
    },
    // 部门下属人员
    getDepPerson (deptId) {
      touristApi.getUserList({ deptId }).then((res) => {
        const { code, rows } = res
        if (code === 200) {
          this.userList = rows
        }
      })
    },
    // 房源分类列表
    HouseMethod (val) {
      this.form.pageNum = 1 // 切换标签时 默认跳转第一页
      this.form.startInMoreTime = undefined // 带看开始时间
      this.form.endInMoreTime = undefined // 带看结束时间
      this.form.sortType = 'DESC'
      this.$refs.ListItem.selectValue = 7
      this.sort = 1
      this.hourseSort = 1 // 切换标签时 刷新排序
      this.form.houseResourceType = Number(val)
      this.activeNum = val
      this.houseList()
    },

    addHouse () {
      // console.log('售房')
      sessionStorage.setItem('history', JSON.stringify({ fromPage: 'add' }))
      this.$router.push('/houses/sell/add')
    },
    // 价格-升序
    caretUp () {},
    houseFloorChange (e) {
      if (e !== '1') {
        this.form.houseFloor = undefined
      }
    }
  },
  watch: {}
}
</script>

<style lang="less" scoped>
.paddingL20 {
  padding-left: 20px;
}
.mr10 {
  margin-right: 10px;
}
.ml5{
  margin-left:5px;
}
.w75 {
  width: 75px;
}
.w80 {
  width: 80px;
}
.w120 {
  width: 120px;
}
.w150 {
  width: 150px;
}
.w180 {
  width: 180px;
}
.menu .ant-tabs-bar {
  width: 100%;
}
.house_list_order {
  display: flex;
  align-items: center;
  /* width: 100%; */
  justify-content: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
}

.houseList {
  background-color: white;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .top {
    background: #fff;
    .top_title {
      padding: 20px;
      display: flex;
      justify-content: center;
      align-content: center;
      .title {
        width: 100%;
        display: flex;
        justify-content: space-between;
        color: #222222;
        h1 {
          font-size: 20px;
          font-weight: 700;
        }
        button {
          width: 100px;
          height: 40px;
        }
      }
      .room-name {
        flex: 1;
        .fy {
          font-size: 20px;
          font-weight: bold;
          color: #000;
        }
        .cz {
          color: var(--ThemeColor);
          font-weight: bold;
          margin-left: 15px;
        }
      }
      .btns {
        .btn {
          background-color: var(--ThemeColor);
          height: 50px;
          width: 102px;
          border-radius: 10px;
          border: none;
        }
      }
    }
    .searchBox {
      margin-top: 13px;
      display: flex;
      justify-content: space-between;
      .new-btn {
        margin-right: 20px;
        width: 100px;
        height: 40px;
      }
      .search {
        // /deep/ .ant-col-14 {
        //   width: 100%;
        // }
        // /deep/ input {
        //   border-radius: 50px;
        //   height: 36px;
        //   width: 100%;
        //   // border: 1px solid black;
        // }
        /deep/.ant-input-affix-wrapper .ant-input {
          // width: 300px;
          border-radius: 30px;
        }
      }
      .rzj {
        display: inline-block;
        border: 1px solid #c0c0c0;
        color: #c0c0c0;
        line-height: 18px;
        font-size: 6px;
        padding-left: 5px;
        padding-right: 5px;
        cursor: pointer;
      }
      .zjselect {
        border: 1px solid red;
        color: red;
        background-color: #fff;
      }
      .yzj {
        display: inline-block;
        line-height: 18px;
        font-size: 6px;
        padding-left: 5px;
        padding-right: 5px;
        border: 1px solid var(--ThemeColor);
        color: var(--ThemeColor);
        background-color: #fef7f1;
        cursor: pointer;
      }
      .mj {
        /deep/.ant-col-14 {
          width: 72.333333%;
        }
      }
      .zj {
        /deep/ .ant-col-14 {
          width: 74.333333%;
        }
      }

      /deep/.ant-form-item {
        margin-bottom: 10px;
      }
    }

    .ant-row {
      .ant-col-6 {
        .ant-col-14 {
          width: 73%;
        }
      }
    }
  }
  .midhr {
    width: 100%;
    height: 5px;
    background-color: #f2f6fc;
  }
  .content {
    .img {
      width: 120px;
      height: 120px;
    }

    padding-top: 20px;
    /deep/ .ant-tabs-tab-active {
      background-color: var(--ThemeColor);
      color: #fff !important;
      border-radius: 5px;
    }
  }
  .rq {
    /deep/ .ant-col-14 {
      width: 80%;
    }
  }
  .topcenter {
    position: fixed;
    top: 43%;
    left: 50%;
  }
  .dateli {
    margin-top: 15px;
    margin-bottom: 15px;
    text-align: right;
    margin-right: 30px;
  }
}
</style>
